import { toast } from 'react-toastify';
import React, { useEffect, useState } from 'react';
import { Button } from 'app/shared/button';
import { MultiSelect } from 'app/shared/select';
import { useAudienceService } from 'hooks/users/audience';

const AddContactToAudience = (props) => {
  const { selected_contacts, fadeOut, handleBulkUnselection } = props;
  const { addContacts, fetchAudiences } = useAudienceService();

  const [audiences, setAudiences] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selected_audience, setSelectedAudience] = useState(0);

  useEffect(() => {
    fetchAudiences({ query_string: 'bool=-is_archived&return_only=name,id,type' }).then(
      ({ audiences }) => {
        setAudiences(audiences.filter((audience) => audience.type !== 'system'));
      }
    );
  }, []);

  const submit = async () => {
    if (!selected_audience.value) {
      toast.error('Please select an audience.');
      return;
    }

    setLoading(true);
    const response = await addContacts(
      selected_audience.value,
      selected_contacts.map((contact) => contact.id)
    );

    if (!response) {
      setLoading(false);
      return;
    }

    setLoading(false);
    toast.success('Contact(s) added to audience.');
    fadeOut();
    handleBulkUnselection();
  };

  return (
    <div>
      <MultiSelect
        options={audiences.map((list) => ({
          label: list.name,
          value: list.id
        }))}
        onChange={setSelectedAudience}
        value={selected_audience}
        placeholder="Select audience"
        isMulti={false}
      />
      <Button onClick={submit} className="w-100" text="Save" loading={loading} />
    </div>
  );
};

export default AddContactToAudience;
